export * from './personalization-drop.component';
